export const PDF_STATUS_COLOR_DONE = '#179577';
export const PDF_STATUS_COLOR_NOT_DONE = '#cd1420';
export const PDF_STATUS_COLOR_PLANNED = '#464646';
export const PDF_STATUS_COLOR_MISSED = '#d79c06';
